
    <div [formGroup]="parentFormGroup" style="width: 100%;">
        <input matInput
               #inputElement
               [formControl]="parentFormGroup.get(parentFormControlName)"
               placeholder="{{placeHolder}}"
               (keyup)="onKeyPressed($event.key)"
               (change)="changedEvent.emit()"
               (focus)="focussed()"
               style="text-align: left; border-bottom: 1px solid rgb(150, 150, 150);"
               [maxlength]="maxLength"
               [type]="type">
        <div *ngIf="maxLength > 0" class="text-right"
             style="font-size: 0.8em;">{{parentFormGroup.get(parentFormControlName).value?.length}} sur {{maxLength}}
            caractères
        </div>
    </div>

